var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgentProductionWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.5H6C6.13261 13.5 6.25975 13.5527 6.35352 13.6465C6.44728 13.7403 6.5 13.8674 6.5 14V22C6.5 22.1326 6.44728 22.2597 6.35352 22.3535C6.25975 22.4473 6.13261 22.5 6 22.5H2C1.86739 22.5 1.74025 22.4473 1.64648 22.3535C1.55272 22.2597 1.5 22.1326 1.5 22V14C1.5 13.8674 1.55272 13.7403 1.64648 13.6465C1.74025 13.5527 1.86739 13.5 2 13.5ZM10 1.5H14C14.1326 1.5 14.2597 1.55272 14.3535 1.64648C14.4473 1.74025 14.5 1.86739 14.5 2V22C14.5 22.1326 14.4473 22.2597 14.3535 22.3535C14.2597 22.4473 14.1326 22.5 14 22.5H10C9.86739 22.5 9.74025 22.4473 9.64648 22.3535C9.55272 22.2597 9.5 22.1326 9.5 22V2C9.5 1.86739 9.55272 1.74025 9.64648 1.64648C9.74025 1.55272 9.86739 1.5 10 1.5ZM18 9.5H22C22.1326 9.5 22.2597 9.55272 22.3535 9.64648C22.4473 9.74025 22.5 9.86739 22.5 10V22C22.5 22.1326 22.4473 22.2597 22.3535 22.3535C22.2597 22.4473 22.1326 22.5 22 22.5H18C17.8674 22.5 17.7403 22.4473 17.6465 22.3535C17.5527 22.2597 17.5 22.1326 17.5 22V10C17.5 9.86739 17.5527 9.74025 17.6465 9.64648C17.7403 9.55272 17.8674 9.5 18 9.5ZM2.5 21.5H5.5V14.5H2.5V21.5ZM10.5 21.5H13.5V2.5H10.5V21.5ZM18.5 21.5H21.5V10.5H18.5V21.5Z",
    fill: "#AF976E",
    stroke: "#AF976E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentProductionWidget);
export default __webpack_public_path__ + "static/media/agent_production_widget.3d52b67e24b65c6a66ff2372b718e2a8.svg";
export { ForwardRef as ReactComponent };